// removed by extract-text-webpack-plugin
module.exports = {"side-h":"_1-p7cAOyGj7pBM0MJd3Vzg_0","disabled-mask":"_3dy2OHSbrgi1gi32fhbRyU_0","coord-dashboard-wrapper":"hRm9wZh5K9u3mhsKsDCsU_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0aa33f34","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/dashboard/index.vue
// module id = Ig2e
// module chunks = 75